import { makeAutoObservable } from 'mobx';
import { waitUntil } from '../../utils/WaitUntil';

class ContentStore {
	rootStore;

	isConnect = false;
	isStart = false;

	downloadProgress = 0;

	defaultIndex = -1;

	seekPercentage = null;

	constructor(root) {
		makeAutoObservable(this);
		this.rootStore = root;
		this.clear();
	}

	setIsStart(value = !this.isStart) {
		this.isStart = value;
	}

	getIsReady() {
		console.log('this.isConnect', this.isConnect);
		console.log('this.isStart', this.isStart);
		console.log(
			'this.rootStore.likuStore.thisLiku?.uuid',
			this.rootStore.likuStore.thisLiku?.uuid,
		);
		return (
			this.isConnect && !this.isStart && this.rootStore.likuStore.thisLiku?.uuid
		);
	}

	setIsConnect(data) {
		console.log('setIsConnect', data);
		this.isConnect = data;
	}

	async checkLikuConnect() {
		const liku = this.rootStore.likuStore.thisLiku;

		if (!liku) return;

		await waitUntil(() => !!this.rootStore.likuStore.thisLiku?.language, 100);

		const language = this.rootStore.likuStore.thisLiku.language;

		if (language !== 'ko') {
			await new Promise((resolve) => {
				this.rootStore.mqttStore.likuMqtt.setLanguage('ko', resolve);
			});
		}

		this.rootStore.mqttStore.playerMqtt.setContentsConnect(() => {
			this.setIsConnect(true);
		});
	}

	setDefaultIndex(value = this.defaultIndex + 1) {
		this.defaultIndex = value;
	}

	setDownloadProgress(value) {
		this.downloadProgress = value;
	}

	setSeekPercentage(percentage) {
		this.seekPercentage = percentage;
	}

	clear(isAll = true) {
		if (isAll) this.isConnect = false;
		this.isStart = false;

		this.downloadProgress = 0;

		this.defaultIndex = -1;

		this.seekPercentage = null;
	}
}

export default ContentStore;
